module.exports = __webpack_public_path__ + "static/media/training_sword.a632df10.png";